import type { Hex, Member } from '../contract.js';
import type { AppState } from '../state/types.js';

/**
 * A profile picture as drawn everywhere (02 §1.12): the member colour with the picture blended on top.
 * `preset` pictures are ready-made art (shown as is, with grain where the design has it); uploads are
 * photos, shown in greyscale. `blend` is how the picture sits on the colour: the prototype's grey
 * drawings and photos are multiplied in; drawings made light on purpose (the backend's presets) are not.
 */
export interface Pfp {
  readonly color: Hex;
  readonly url: string | null;
  readonly preset: boolean;
  readonly blend: 'multiply' | 'normal';
}

export function pfpOf(st: AppState, color: Hex, pic: Member['pic'] | null | undefined): Pfp {
  if (pic && typeof pic === 'object' && pic.url) return { color, url: pic.url, preset: false, blend: 'multiply' };
  if (typeof pic === 'string' && pic) {
    const preset = st.presets.find((item) => item.id === pic);
    if (preset) return { color, url: preset.url, preset: true, blend: preset.blend ?? 'multiply' };
  }
  return { color, url: null, preset: false, blend: 'multiply' };
}

export const pfpOfMember = (st: AppState, member: Member): Pfp => pfpOf(st, member.color, member.pic);
